module.exports = __webpack_public_path__ + "static/AIIconCommon-d42b77966d28954125e6b7294328bf15.png";